import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

// Totally Bamboo — New-customers campaign (adc_q3qev6dwzx). Real lifetime
// aggregates from ANALYTICS.ADS.CAMPAIGN_PERIODS (complete months through Jun 2026).
export const campTbNew: FaireAdCampaignEntity = {
  token: "camp_tb_new",
  type: "adCampaign",
  advertiserProfileToken: "adv_totally_bamboo",
  segment: "NEW_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 10000,
  startedRunningAt: "2023-10-07",
  segmentMetrics: {
    numCustomersAcquired: 1078,
    salesDollars: 606831,
    totalAdsSpendDollars: 95503,
    cpaDollars: 89,
    bestEstimateSalesDollars: 606831,
    bestEstimateRoas: 6.35,
  },
  performancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
